import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IOrderDetailsRequestParams,
} from "@tm/api-utils";
import { LOB } from "@tm/isomorphic-utils";
import { getLobOnServerSide } from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getOrderDetailsV2 = async (
  data: IOrderDetailsRequestParams
): Promise<any> => {
  try {
    const { partner, bookingId, headers, cmp, query, dvid } = data || {};
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId,
      ...query,
    };

    const urlParams = setURLQueryParams(params);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.ORDER_DETAIL_V2}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp, dvid },
      }
    );

    return response;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
